function roundToBase(number: number, base: number): string {
  const result = number / base;

  if (result.toFixed(1).split(".")[1] === "0") {
    return result.toFixed(0);
  }

  return result.toFixed(1);
}

export function bigNumberConverter(number?: number | bigint | null): string | undefined {
  if (!number || typeof number === "string") return undefined;
  const num = Number(number);
  if (Number.isNaN(num)) return undefined;
  switch (true) {
    case num < 1000:
      return String(num);
    case num < 1000000:
      return `${roundToBase(num, 1000)}K`;
    case num < 1000000000:
      return `${roundToBase(num, 1000000)}M`;
    case num < 1000000000000:
      return `${roundToBase(num, 1000000000)}B`;
    case num < 1000000000000000:
      return `${roundToBase(num, 1000000000000)}T`;
    default:
      return `1T+`;
  }
}
